module.exports = __webpack_public_path__ + "i18n/zh-CN.7ce41c1874e8a15ffdb5e0563cf4c682.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-CN.json
// module id = 1107
// module chunks = 76